import React from "react";
import { useTranslation } from 'react-i18next';

const Modal = ({ open, onClose, children, className = "", ...props }) => {
  const { t } = useTranslation();
  if (!open) return null;
  return (
    <div className="modal-overlay" onClick={onClose}>
      <div
        className={"modal-content " + className}
        onClick={e => e.stopPropagation()}
        {...props}
      >
        {children}
      </div>
    </div>
  );
};

export default Modal;
